import { Component } from '@angular/core';

import { AnswerTypeComponent } from '../answer-type.component';
import { InputContentDataExtraValueType } from 'client/models';
import { FormControl } from '@angular/forms';
import { FormStore } from '../../common/form.store';
import { Subscription } from 'rxjs';


@Component({
  selector: 'answer-radio',
  templateUrl: './answer-radio.component.html',
  standalone: false
})
export class AnswerRadioComponent extends AnswerTypeComponent {

  public InputContentDataExtraValueType = InputContentDataExtraValueType;
  public dataStringValue;
  public dataStringExtraValue;
  public dataKey;

  private subs = new Subscription();

  ngOnInit() {
    super.ngOnInit();
    const val = this.formControlObj.value;
    this.dataStringExtraValue = val?.dataStringExtraValue ? String(val?.dataStringExtraValue).trim() : '';
    this.dataKey = val?.dataStringValue;

    const sub1 = FormStore.reset$.subscribe(() => {
      setTimeout(() => {
        this.dataStringValue = '';
        this.dataStringExtraValue = '';
        this.dataKey = undefined;
        (this.formControlObj as FormControl).patchValue('');
      });
    });
    this.subs.add(sub1);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subs.unsubscribe();
  }

  public selectOption() {
    const optionControl = this.formControlObj as FormControl;
    optionControl.setValue({ dataStringValue: this.dataKey, dataStringExtraValue: this.dataStringExtraValue });
  }

}
